// Module
var code = "<div class=\"input-group\"> <input class=\"form-control\" ng-model=\"model[options.key]\" readonly=\"readonly\"/> <div class=\"input-group-addon\" style=\"cursor:pointer\" ng-click=\"openMachineModal()\"> <i class=\"fa fa-search\"></i> </div> </div> ";
// Exports
export default code;